import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {FotoNasabahSalesRoutingModule} from "./foto-nasabah-sales-routing.module";
import {GlobalModule} from "../global/global.module";
import {AngularSignaturePadModule} from "@almothafar/angular-signature-pad";
import {FotoNasabahSalesComponent} from "./foto-nasabah-sales.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FotoNasabahSalesRoutingModule,
    GlobalModule,
    AngularSignaturePadModule,
  ],
  declarations: [
    FotoNasabahSalesComponent
  ]
})
export class FotoNasabahSalesModule {

}
